import { render, staticRenderFns } from "./CollectionListLink.vue?vue&type=template&id=3bf277ec&scoped=true&"
import script from "./CollectionListLink.vue?vue&type=script&lang=js&"
export * from "./CollectionListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf277ec",
  null
  
)

export default component.exports